import { render, staticRenderFns } from "./last6MonthsStats.vue?vue&type=template&id=4804f776&scoped=true"
import script from "./last6MonthsStats.vue?vue&type=script&lang=js"
export * from "./last6MonthsStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4804f776",
  null
  
)

export default component.exports